import Vue from 'vue'
import { isIOS } from '../helpers'

export default function (el) {
  if (!isIOS) return false
  const fixTargets = [document.body, document.documentElement]

  el.addEventListener('focus', function () {
    fixTargets.forEach(target => {
      target.style.height = '100%'
      target.style.overflow = 'auto'
      target.style.webkitOverFlowScrolling = 'touch'
    })
  })

  el.addEventListener('blur', function () {
    fixTargets.forEach(target => {
      target.removeAttribute('style')
    })
  })
}



// WEBPACK FOOTER //
// ./sportspower/assets/es6/directives/FixedFocus.js